<template>
  <div>
    <div class="view-header">
      <h1>{{$store.state.meta.title}}</h1>
      <div class="func-list">
      </div>
    </div>
    <div class="table">
      <el-table
        size="medium"
        :data="list"
        style="width: 100%">
        <el-table-column
          prop="template_title"
          label="报告类型"
          width="180">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="提交报告时间"
          width="200">
          <template slot-scope="scope">
            {{scope.row.start_time}}-{{scope.row.end_time}}
          </template>
        </el-table-column>
        <el-table-column
          label="导出方式">
          <template slot-scope="scope">
            {{['','Excel','PDF'][scope.row.export_type]}}
          </template>
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="导出时间"
          width="160">
        </el-table-column>
        <el-table-column
          label="状态">
          <template slot-scope="scope">
            {{['','未处理','处理中','处理完成','处理失败'][scope.row.status]}}
          </template>
        </el-table-column>
        <el-table-column
          prop="count"
          label="数据条数">
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status==4"
              type="text"
              @click="reHandle(scope.row.export_aysn_report_id)">
              <i class="el-icon-refresh" style="font-size: 20px;"></i>
              重新处理
            </el-button>
            <el-button
              v-if="scope.row.status==3&&scope.row.export_type==1&&scope.row.count>0"
              type="text"
              @click="onDownload(scope.row)">
              <img class="download-icon" src="~@/assets/img/icon_excel.svg">
              下载Excel
            </el-button>
            <el-button
              v-if="scope.row.status==3&&scope.row.export_type==2&&scope.row.count>0"
              type="text"
              @click="onDownload(scope.row)">
              <img class="download-icon" src="~@/assets/img/icon_compressed_file.svg">
              下载PDF
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        :hide-on-single-page="totalPage<2"
        background
        :current-page="currentPage"
        :page-size="20"
        layout="prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getExportList, getReportDateList, inserExport } from '@/api';

export default {
  name: 'ExportList',
  data() {
    return {
      list: [],
      totalCount: 0,
      totalPage: 1,
      currentPage: 0,
    };
  },
  created() {
    this._getList(1);
  },
  methods: {
    _getList(page) {
      getExportList({ page }).then((res) => {
        if (res.status === 0) {
          const data = res.data.list;
          const { oss_url } = res.data;
          this.totalCount = data.totalCount;
          this.totalPage = data.totalPage;
          this.currentPage = parseInt(data.currentPage);
          for (const item of data.list) {
            item.file_path = oss_url + item.file_path;
          }
          this.list = data.list;
        } else {
          this.list = [];
          this.totalCount = 0;
          this.totalPage = 1;
          this.currentPage = 0;
        }
      });
    },
    handleCurrentChange(val) {
      this._getList(val);
    },
    reHandle(export_aysn_report_id) {
      inserExport({ export_aysn_report_id: export_aysn_report_id}).then((res) => {
        if (res.status === 0) {
          this._getList(1);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onDownload({ file_path }) {
      window.location.href = file_path;
    },
  },
};
</script>

<style scoped lang="scss">
.download-icon{
  width: 20px;
  height: auto;
  vertical-align: middle;
}
</style>
